module.exports = __webpack_public_path__ + "static/media/ARI-STEVI Pro 422-462.cd6caa91.jpg";